import { useStyles } from './style';
import { PageContent } from './PageContent';
import './Home.css';
import { Container, Typography } from '@mui/material';

const Home = () => {
  const { classes } = useStyles();

  return (
    <main className={classes.content}>
      <div>
        <Container maxWidth="lg" className={classes.container}>
          <div>
            <div className={classes.item}>
              <Typography variant="h5" fontWeight="bold">
                Forge Tax Documents and Statements
              </Typography>
            </div>
            <PageContent />
          </div>
        </Container>
      </div>
    </main>
  );
};

export default Home;
